// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, onSnapshot } from "firebase/firestore";
import getAnalytics from './../Services/getAnalytics';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB8V_aa_Qtru_ARr-exsDDVlYmYX41N1aM",
  authDomain: "afomedia-2ad62.firebaseapp.com",
  projectId: "afomedia-2ad62",
  storageBucket: "afomedia-2ad62.appspot.com",
  messagingSenderId: "676854809440",
  appId: "1:676854809440:web:ab32da9cb012e134bb9405",
  measurementId: "G-BW9CBG06K8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
export { db, auth , analytics};